import React from 'react'
import Form from 'react-bootstrap/Form'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Select from 'react-select';
import { reactSelectStyles } from '../../../../utils/constants';
import CustomAccordion from '../../../CustomAccordion/CustomAccordion';

import "./OperationsLabrumAndInstability.scss"

const slapProcedureDetailOptions = [
  {value: "Debridement", label: "Debridement"},
  {value: "Repair", label: "Repair"},
]

const slapRepairDetailOptions = [
  {value: "Through muscle", label: "Through muscle"},
  {value: "Through interval only", label: "Through interval only"},
]

const labralRepairProcedureDetailOptions = [
  {value: "Debridement", label: "Debridement"},
  {value: "Repair", label: "Repair"},
]

const labralRepairRepairDetailOptions = [
  {value: "Knotless anchor - Inferior anchor", label: "Knotless anchor - Inferior anchor"},
  {value: "Knotless anchor - Other", label: "Knotless anchor - Other"},
  {value: "Suture Anchor - Inferior Anchor", label: "Suture Anchor - Inferior Anchor"},
  {value: "Suture anchor - Other", label: "Suture anchor - Other"},
  {value: "Combination knotless and suture anchor", label: "Combination knotless and suture anchor"},
]

const capsulorrhaphyProcedureDetailOptions = [
  {value: "Anterior", label: "Anterior"},
  {value: "Posterior", label: "Posterior"},
  {value: "Inferior", label: "Inferior"},
  {value: "Superior", label: "Superior"},
]

const haglRepairTypeOptions = [
  {value: "Soft Tissue", label: "Soft Tissue"},
  {value: "Anchor", label: "Anchor"},
]

const alpsaRepairProcedureDetailOptions = [
  {value: "Soft Tissue", label: "Soft Tissue"},
  {value: "Anchor", label: "Anchor"},
]

const remplissageProcedureDetailOptions = [
  {value: "Anterior", label: "Anterior"},
  {value: "Posterior", label: "Posterior"},
  {value: "Other", label: "Other"},
]

const sugscapularisAugmentationProcedureDetailOptions = [
  {value: "Subscapularis elongation", label: "Subscapularis elongation"},
  {value: "Extrarotation degree", label: "Extrarotation degree"},
]

const sugscapularisAugmentationRepairDetailOptions = [
  {value: "Knotless anchor - Inferior anchor", label: "Knotless anchor - Inferior anchor"},
  {value: "Knotless anchor - Other", label: "Knotless anchor - Other"},
  {value: "Suture Anchor - Inferior Anchor", label: "Suture Anchor - Inferior Anchor"},
  {value: "Suture anchor - Other", label: "Suture anchor - Other"},
  {value: "Combination knotless and suture anchor", label: "Combination knotless and suture anchor"},
  {value: "Suture only", label: "Suture only"},
]

const OperationsLabrumAndInstability = ({ form, formData, arrayIndex, onChangeHandler, onRemoveHandler ,
  showToggleButtons = false,
  filterType = 'include',
  onFilterTypeChange = () => {},
  activeKey,
  onAccordionChange = () => {},
  closeFromBottom = false
}) => {
  const handleAccordionToggle = () => {
    onAccordionChange(form);
  };
  switch(form) {
    case "slap": {
      return (
        <CustomAccordion
          title="SLAP"
          previewData={formData}
          showToggleButtons={showToggleButtons}
          filterType={filterType}
          onFilterTypeChange={onFilterTypeChange}
          onRemove={() => onRemoveHandler(arrayIndex)}
          category="operations-labrum-instability"
          isOpen={activeKey === form}
          onToggle={handleAccordionToggle}
          closeFromBottom={closeFromBottom}
        >
                <Form>
                  <Row>
                    <Col>
                      <Form.Label>Primary or Revision</Form.Label>
                      <Form.Select
                        value={formData.primaryOrRevision}
                        onChange={(e) => {onChangeHandler(arrayIndex, "primaryOrRevision", e.target.value)}}
                      >
                        <option value="" hidden>Select an option</option>
                        <option value="Primary">Primary</option>
                        <option value="Revision">Revision</option>
                      </Form.Select>
                    </Col>
                    <Col>
                      <Form.Check
                  type="checkbox"
                  id={`open-${arrayIndex}`}
                  checked={formData.open}
                  label="Open"
                  onChange={(e) => {onChangeHandler(arrayIndex, "open", e.target.checked)}}
                />
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <Form.Label>Procedure Details</Form.Label>
                      <Select
                        isMulti
                        value={slapProcedureDetailOptions.filter(option => formData.procedures.split(",").includes(option.value))}
                        name="procedures"
                        options={slapProcedureDetailOptions}
                        className="basic-multi-select"
                        classNamePrefix="select"
                        menuPortalTarget={document.body}
                        styles={reactSelectStyles}
                        onChange={(selectedValues) => {onChangeHandler(arrayIndex, "procedures", selectedValues.map(selectedValue => selectedValue.value).join(","))}}
                      />
                    </Col>
                    <Col>
                      <Form.Label>Repair Details</Form.Label>
                      <Select
                        isMulti
                        value={slapRepairDetailOptions.filter(option => formData.repairDetails.split(",").includes(option.value))}
                        name="repairDetails"
                        options={slapRepairDetailOptions}
                        className="basic-multi-select"
                        classNamePrefix="select"
                        menuPortalTarget={document.body}
                        styles={reactSelectStyles}
                        onChange={(selectedValues) => {onChangeHandler(arrayIndex, "repairDetails", selectedValues.map(selectedValue => selectedValue.value).join(","))}}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <Form.Label>Type of Anchor Used</Form.Label>
                      <Form.Select
                        value={formData.typeOfAnchorUsed}
                        onChange={(e) => {onChangeHandler(arrayIndex, "typeOfAnchorUsed", e.target.value)}}
                      >
                        <option value="" hidden>Select an option</option>
                        <option value="Knotless anchor">Knotless anchor</option>
                        <option value="Suture Anchor">Suture Anchor</option>
                        <option value="Combination knotless and suture anchor">Combination knotless and suture anchor</option>
                      </Form.Select>
                    </Col>
                  </Row>
                </Form>
              </CustomAccordion>
      )
    }
    case "labralRepair": {
      return (
        <CustomAccordion
          title="Labral Repair"
          previewData={formData}
          showToggleButtons={showToggleButtons}
          filterType={filterType}
          onFilterTypeChange={onFilterTypeChange}
          onRemove={() => onRemoveHandler(arrayIndex)}
          category="operations-labrum-instability"
          isOpen={activeKey === form}
          onToggle={handleAccordionToggle}
          closeFromBottom={closeFromBottom}
        >
                <Form>
                  <Row>
                    <Col>
                      <Form.Label>Primary or Revision</Form.Label>
                      <Form.Select
                        value={formData.primaryOrRevision}
                        onChange={(e) => {onChangeHandler(arrayIndex, "primaryOrRevision", e.target.value)}}
                      >
                        <option value="" hidden>Select an option</option>
                        <option value="Primary">Primary</option>
                        <option value="Revision">Revision</option>
                      </Form.Select>
                    </Col>
                    <Col>
                      <Form.Check
                  type="checkbox"
                  id={`open-${arrayIndex}`}
                  checked={formData.open}
                  label="Open"
                  onChange={(e) => {onChangeHandler(arrayIndex, "open", e.target.checked)}}
                />
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <Form.Label>Procedure Details</Form.Label>
                      <Select
                        isMulti
                        value={labralRepairProcedureDetailOptions.filter(option => formData.procedures.split(",").includes(option.value))}
                        name="procedures"
                        options={labralRepairProcedureDetailOptions}
                        className="basic-multi-select"
                        classNamePrefix="select"
                        menuPortalTarget={document.body}
                        styles={reactSelectStyles}
                        onChange={(selectedValues) => {onChangeHandler(arrayIndex, "procedures", selectedValues.map(selectedValue => selectedValue.value).join(","))}}
                      />
                    </Col>
                    <Col>
                      <Form.Label>Repair Details</Form.Label>
                      <Select
                        isMulti
                        value={labralRepairRepairDetailOptions.filter(option => formData.repairDetails.split(",").includes(option.value))}
                        name="repairDetails"
                        options={labralRepairRepairDetailOptions}
                        className="basic-multi-select"
                        classNamePrefix="select"
                        menuPortalTarget={document.body}
                        styles={reactSelectStyles}
                        onChange={(selectedValues) => {onChangeHandler(arrayIndex, "repairDetails", selectedValues.map(selectedValue => selectedValue.value).join(","))}}
                      />
                    </Col>
                  </Row>
                </Form>
              </CustomAccordion>
      )
    }
    case "capsulorrhaphy": {
      return (
        <CustomAccordion
          title="Capsulorrhaphy"
          previewData={formData}
          showToggleButtons={showToggleButtons}
          filterType={filterType}
          onFilterTypeChange={onFilterTypeChange}
          onRemove={() => onRemoveHandler(arrayIndex)}
          category="operations-labrum-instability"
          isOpen={activeKey === form}
          onToggle={handleAccordionToggle}
          closeFromBottom={closeFromBottom}
        >
                <Form>
                  <Row>
                    <Col>
                      <Form.Label>Primary or Revision</Form.Label>
                      <Form.Select
                        value={formData.primaryOrRevision}
                        onChange={(e) => {onChangeHandler(arrayIndex, "primaryOrRevision", e.target.value)}}
                      >
                        <option value="" hidden>Select an option</option>
                        <option value="Primary">Primary</option>
                        <option value="Revision">Revision</option>
                      </Form.Select>
                    </Col>
                    <Col>
                      <Form.Label>Open or Arthroscopic</Form.Label>
                      <Form.Select
                        value={formData.openOrArthroscopic}
                        onChange={(e) => {onChangeHandler(arrayIndex, "openOrArthroscopic", e.target.value)}}
                      >
                        <option value="" hidden>Select an option</option>
                        <option value="Open">Open</option>
                        <option value="Arthroscopic">Arthroscopic</option>
                      </Form.Select>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <Form.Label>Procedure Details</Form.Label>
                      <Select
                        isMulti
                        value={capsulorrhaphyProcedureDetailOptions.filter(option => formData.procedures.split(",").includes(option.value))}
                        name="procedures"
                        options={capsulorrhaphyProcedureDetailOptions}
                        className="basic-multi-select"
                        classNamePrefix="select"
                        menuPortalTarget={document.body}
                        styles={reactSelectStyles}
                        onChange={(selectedValues) => {onChangeHandler(arrayIndex, "procedures", selectedValues.map(selectedValue => selectedValue.value).join(","))}}
                      />
                    </Col>
                    <Col>
                      <Form.Check
                  type="checkbox"
                  id={`withAnchors-${arrayIndex}`}
                  checked={formData.withAnchors}
                  label="With anchors"
                  onChange={(e) => {onChangeHandler(arrayIndex, "withAnchors", e.target.checked)}}
                />
                    </Col>
                  </Row>
                </Form>
              </CustomAccordion>
      )
    }
    case "haglRepair": {
      return (
        <CustomAccordion
          title="HAGL Repair"
          previewData={formData}
          showToggleButtons={showToggleButtons}
          filterType={filterType}
          onFilterTypeChange={onFilterTypeChange}
          onRemove={() => onRemoveHandler(arrayIndex)}
          category="operations-labrum-instability"
          isOpen={activeKey === form}
          onToggle={handleAccordionToggle}
          closeFromBottom={closeFromBottom}
        >
                <Form>
                  <Row>
                    <Col>
                      <Form.Label>Primary or Revision</Form.Label>
                      <Form.Select
                        value={formData.primaryOrRevision}
                        onChange={(e) => {onChangeHandler(arrayIndex, "primaryOrRevision", e.target.value)}}
                      >
                        <option value="" hidden>Select an option</option>
                        <option value="Primary">Primary</option>
                        <option value="Revision">Revision</option>
                      </Form.Select>
                    </Col>
                    <Col>
                      <Form.Check
                  type="checkbox"
                  id={`open-${arrayIndex}`}
                  checked={formData.open}
                  label="Open"
                  onChange={(e) => {onChangeHandler(arrayIndex, "open", e.target.checked)}}
                />
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <Form.Label>Type</Form.Label>
                      <Select
                        isMulti
                        value={haglRepairTypeOptions.filter(option => formData.haglRepairType.split(",").includes(option.value))}
                        name="procedures"
                        options={haglRepairTypeOptions}
                        className="basic-multi-select"
                        classNamePrefix="select"
                        menuPortalTarget={document.body}
                        styles={reactSelectStyles}
                        onChange={(selectedValues) => {onChangeHandler(arrayIndex, "haglRepairType", selectedValues.map(selectedValue => selectedValue.value).join(","))}}
                      />
                    </Col>
                  </Row>
                </Form>
              </CustomAccordion>
      )
    }
    case "alpsaRepair": {
      return (
        <CustomAccordion
          title="ALPSA Repair"
          previewData={formData}
          showToggleButtons={showToggleButtons}
          filterType={filterType}
          onFilterTypeChange={onFilterTypeChange}
          onRemove={() => onRemoveHandler(arrayIndex)}
          category="operations-labrum-instability"
          isOpen={activeKey === form}
          onToggle={handleAccordionToggle}
          closeFromBottom={closeFromBottom}
        >
                <Form>
                  <Row>
                    <Col>
                      <Form.Label>Primary or Revision</Form.Label>
                      <Form.Select
                        value={formData.primaryOrRevision}
                        onChange={(e) => {onChangeHandler(arrayIndex, "primaryOrRevision", e.target.value)}}
                      >
                        <option value="" hidden>Select an option</option>
                        <option value="Primary">Primary</option>
                        <option value="Revision">Revision</option>
                      </Form.Select>
                    </Col>
                    <Col>
                      <Form.Check
                  type="checkbox"
                  id={`open-${arrayIndex}`}
                  checked={formData.open}
                  label="Open"
                  onChange={(e) => {onChangeHandler(arrayIndex, "open", e.target.checked)}}
                />
                    </Col>
                  </Row>
                  <Row>
                  <Col>
                      <Form.Label>Procedure Details</Form.Label>
                      <Select
                        isMulti
                        value={alpsaRepairProcedureDetailOptions.filter(option => formData.procedures.split(",").includes(option.value))}
                        name="procedures"
                        options={alpsaRepairProcedureDetailOptions}
                        className="basic-multi-select"
                        classNamePrefix="select"
                        menuPortalTarget={document.body}
                        styles={reactSelectStyles}
                        onChange={(selectedValues) => {onChangeHandler(arrayIndex, "procedures", selectedValues.map(selectedValue => selectedValue.value).join(","))}}
                      />
                    </Col>
                  </Row>
                </Form>
              </CustomAccordion>
      )
    }
    case "remplissage": {
      return (
        <CustomAccordion
          title="Remplissage"
          previewData={formData}
          showToggleButtons={showToggleButtons}
          filterType={filterType}
          onFilterTypeChange={onFilterTypeChange}
          onRemove={() => onRemoveHandler(arrayIndex)}
          category="operations-labrum-instability"
          isOpen={activeKey === form}
          onToggle={handleAccordionToggle}
          closeFromBottom={closeFromBottom}
        >
                <Form>
                  <Row>
                    <Col>
                      <Form.Label>Primary or Revision</Form.Label>
                      <Form.Select
                        value={formData.primaryOrRevision}
                        onChange={(e) => {onChangeHandler(arrayIndex, "primaryOrRevision", e.target.value)}}
                      >
                        <option value="" hidden>Select an option</option>
                        <option value="Primary">Primary</option>
                        <option value="Revision">Revision</option>
                      </Form.Select>
                    </Col>
                    <Col>
                      <Form.Label>Open or Arthroscopic</Form.Label>
                      <Form.Select
                        value={formData.openOrArthroscopic}
                        onChange={(e) => {onChangeHandler(arrayIndex, "openOrArthroscopic", e.target.value)}}
                      >
                        <option value="" hidden>Select an option</option>
                        <option value="Open">Open</option>
                        <option value="Arthroscopic">Arthroscopic</option>
                      </Form.Select>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <Form.Label>Procedure Details</Form.Label>
                      <Select
                        isMulti
                        value={remplissageProcedureDetailOptions.filter(option => formData.procedures.split(",").includes(option.value))}
                        name="procedures"
                        options={remplissageProcedureDetailOptions}
                        className="basic-multi-select"
                        classNamePrefix="select"
                        menuPortalTarget={document.body}
                        styles={reactSelectStyles}
                        onChange={(selectedValues) => {onChangeHandler(arrayIndex, "procedures", selectedValues.map(selectedValue => selectedValue.value).join(","))}}
                      />
                    </Col>
                  </Row>
                </Form>
              </CustomAccordion>
      )
    }
    case "subscapularisAugmentation": {
      return (
        <CustomAccordion
          title="Subscapularis Augmentation"
          previewData={formData}
          showToggleButtons={showToggleButtons}
          filterType={filterType}
          onFilterTypeChange={onFilterTypeChange}
          onRemove={() => onRemoveHandler(arrayIndex)}
          category="operations-labrum-instability"
          isOpen={activeKey === form}
          onToggle={handleAccordionToggle}
          closeFromBottom={closeFromBottom}
        >
                <Form>
                  <Row>
                    <Col>
                      <Form.Label>Primary or Revision</Form.Label>
                      <Form.Select
                        value={formData.primaryOrRevision}
                        onChange={(e) => {onChangeHandler(arrayIndex, "primaryOrRevision", e.target.value)}}
                      >
                        <option value="" hidden>Select an option</option>
                        <option value="Primary">Primary</option>
                        <option value="Revision">Revision</option>
                      </Form.Select>
                    </Col>
                    <Col>
                      <Form.Check
                  type="checkbox"
                  id={`open-${arrayIndex}`}
                  checked={formData.open}
                  label="Open"
                  onChange={(e) => {onChangeHandler(arrayIndex, "open", e.target.checked)}}
                />
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <Form.Label>Procedure Details</Form.Label>
                      <Select
                        isMulti
                        value={sugscapularisAugmentationProcedureDetailOptions.filter(option => formData.procedures.split(",").includes(option.value))}
                        name="procedures"
                        options={sugscapularisAugmentationProcedureDetailOptions}
                        className="basic-multi-select"
                        classNamePrefix="select"
                        menuPortalTarget={document.body}
                        styles={reactSelectStyles}
                        onChange={(selectedValues) => {onChangeHandler(arrayIndex, "procedures", selectedValues.map(selectedValue => selectedValue.value).join(","))}}
                      />
                    </Col>
                    <Col>
                      <Form.Label>Repair Details</Form.Label>
                      <Select
                        isMulti
                        value={sugscapularisAugmentationRepairDetailOptions.filter(option => formData.repairDetails.split(",").includes(option.value))}
                        name="repairDetails"
                        options={sugscapularisAugmentationRepairDetailOptions}
                        className="basic-multi-select"
                        classNamePrefix="select"
                        menuPortalTarget={document.body}
                        styles={reactSelectStyles}
                        onChange={(selectedValues) => {onChangeHandler(arrayIndex, "repairDetails", selectedValues.map(selectedValue => selectedValue.value).join(","))}}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <Form.Label>Extrarotation degree</Form.Label>
                      <Form.Control
                        type="number"
                        step={1}
                        min={-360}
                        max={360}
                        value={formData.extrarotationDegree}
                        onChange={(e) => {onChangeHandler(arrayIndex, "extrarotationDegree", e.target.value)}}
                      ></Form.Control>
                    </Col>
                    <Col>
                      <Form.Label>Subscapularis elongation</Form.Label>
                      <Form.Control
                        type="number"
                        step={1}
                        min={0}
                        max={300}
                        value={formData.subscapularisElongation}
                        onChange={(e) => {onChangeHandler(arrayIndex, "subscapularisElongation", e.target.value)}}
                      ></Form.Control>
                    </Col>
                  </Row>
                </Form>
              </CustomAccordion>
      )
    }
    case "glenoidBoneGraftProcedure": {
      return (
        <CustomAccordion
          title="Glenoid Bone Graft Procedure"
          previewData={formData}
          showToggleButtons={showToggleButtons}
          filterType={filterType}
          onFilterTypeChange={onFilterTypeChange}
          onRemove={() => onRemoveHandler(arrayIndex)}
          category="operations-labrum-instability"
          isOpen={activeKey === form}
          onToggle={handleAccordionToggle}
          closeFromBottom={closeFromBottom}
        >
                <Form>
                  <Row>
                    <Col>
                      <Form.Label>Primary or Revision</Form.Label>
                      <Form.Select
                        value={formData.primaryOrRevision}
                        onChange={(e) => {onChangeHandler(arrayIndex, "primaryOrRevision", e.target.value)}}
                      >
                        <option value="" hidden>Select an option</option>
                        <option value="Primary">Primary</option>
                        <option value="Revision">Revision</option>
                      </Form.Select>
                    </Col>
                    <Col>
                      <Form.Label>Open or Arthroscopic</Form.Label>
                      <Form.Select
                        value={formData.openOrArthroscopic}
                        onChange={(e) => {onChangeHandler(arrayIndex, "openOrArthroscopic", e.target.value)}}
                      >
                        <option value="" hidden>Select an option</option>
                        <option value="Open">Open</option>
                        <option value="Arthroscopic">Arthroscopic</option>
                      </Form.Select>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <Form.Label>Procedure Details</Form.Label>
                      <Form.Select
                        value={formData.procedures}
                        onChange={(e) => {onChangeHandler(arrayIndex, "procedures", e.target.value)}}
                      >
                        <option value="" hidden>Select an option</option>
                        <option value="Latarjet">Latarjet</option>
                        <option value="Other glenoid bone graft procedure">Other glenoid bone graft procedure</option>
                      </Form.Select>
                    </Col>
                    <Col>
                      <Form.Label>Type of bone graft used</Form.Label>
                      <Form.Select
                        value={formData.typeOfBoneGraftUsed}
                        onChange={(e) => {onChangeHandler(arrayIndex, "typeOfBoneGraftUsed", e.target.value)}}
                      >
                        <option value="" hidden>Select an option</option>
                        <option value="Allograft">Allograft (Fill in details in graft catalog)</option>
                        <option value="Autograft">Autograft (Fill in details in graft catalog)</option>
                        <option value="Synthetic bone void filler">Synthetic bone void filler (Fill in details in graft catalog)</option>
                      </Form.Select>
                    </Col>
                  </Row>
                </Form>
              </CustomAccordion>
      )
    }
    case "humeralBoneGraftProcedure": {
      return (
        <CustomAccordion
          title="Humeral Bone Graft Procedure"
          previewData={formData}
          showToggleButtons={showToggleButtons}
          filterType={filterType}
          onFilterTypeChange={onFilterTypeChange}
          onRemove={() => onRemoveHandler(arrayIndex)}
          category="operations-labrum-instability"
          isOpen={activeKey === form}
          onToggle={handleAccordionToggle}
          closeFromBottom={closeFromBottom}
        >
                <Form>
                  <Row>
                    <Col>
                      <Form.Label>Primary or Revision</Form.Label>
                      <Form.Select
                        value={formData.primaryOrRevision}
                        onChange={(e) => {onChangeHandler(arrayIndex, "primaryOrRevision", e.target.value)}}
                      >
                        <option value="" hidden>Select an option</option>
                        <option value="Primary">Primary</option>
                        <option value="Revision">Revision</option>
                      </Form.Select>
                    </Col>
                    <Col>
                      <Form.Label>Type of bone graft used</Form.Label>
                      <Form.Select
                        value={formData.typeOfBoneGraftUsed}
                        onChange={(e) => {onChangeHandler(arrayIndex, "typeOfBoneGraftUsed", e.target.value)}}
                      >
                        <option value="" hidden>Select an option</option>
                        <option value="Allograft">Allograft (Fill in details in graft catalog)</option>
                        <option value="Autograft">Autograft (Fill in details in graft catalog)</option>
                        <option value="Synthetic bone void filler">Synthetic bone void filler (Fill in details in graft catalog)</option>
                      </Form.Select>
                    </Col>
                  </Row>
                </Form>
              </CustomAccordion>
      )
    }
    default: {
      return null
    }
  }
}

export default OperationsLabrumAndInstability